import { connect } from "react-redux";
import { bindActionCreators, Dispatch, AnyAction } from "@reduxjs/toolkit";
import { MyPublicationEditContainerProps } from "../../../../interfaces/containers";
import EntryPoint from "../../../../pages/Profile/MyPublications/Edit";
import {
    getPublication, 
    getArticlesFromPublication, 
    setUploadImages,
    updatePublication, 
    cleanUpdate, 
    cleanAll, 
    postPublicationImages, 
    deletePublicationImage,
    cleanImagesSaved,

} from "../../../../actions/publication";
import { getYears, setIsNegotiate, getAdditionalCharacters, setAdditionalCharacters, postPublicationsImagesForEdit } from "../../../../actions/salePost";
import { getVersions } from "../../../../actions/publications";
import { getModels } from "../../../../actions/filters";
import { getBrands } from "../../../../actions/filters";
import { getMyPublicationsRequest } from "../../../../actions/profile";

function mapStateToProps(state: MyPublicationEditContainerProps) {
    return{
        publication: state.publication,
        models: state.publications.models,
        versions: state.publications.versions,
        updateReducer: state.publication.update,
        brands: state.publications.brands,
        additionalCharacters: state.salePost.additional_characters
    }
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
    return bindActionCreators({
        getModels,
        getVersions,
        getPublication,
        getArticlesFromPublication,
        setUploadImages,
        updatePublication,
        cleanAll,
        cleanUpdate,
        postPublicationsImages: postPublicationsImagesForEdit,
        deletePublicationImage,
        cleanImagesSaved,
        getMyPublicationsRequest,
        getYears,
        getBrands,
        setIsNegotiate,
        getAdditionalCharacters,
        setAdditionalCharacters
    }, dispatch)
};

export default connect(mapStateToProps, mapDispatchToProps)(EntryPoint);